var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{staticClass:"mr-0",attrs:{"cols":"5"}},[_c('vue-single-select',{attrs:{"classes":{
           input: 'form-control',
           dropdown: 'dropdown p-0',
         },"options":_vm.users,"optionLabel":"nickname"},scopedSlots:_vm._u([{key:"option",fn:function({ option }){return [_c('div',{},[_c('span',[_vm._v(" "+_vm._s(option.nickname))])])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }